import React, { useState, useEffect } from "react";
import "../style.css";

export const FrameBottom = ({ RateOptionClick, LOFooterImage }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isMediumSize, setIsMediumSize] = useState(
    window.innerWidth >= 768 && window.innerWidth < 1201
  );

  const [isLargeDeskTop, setIsLargeDeskTop] = useState(
    window.innerWidth > 1399
  );
  const isProduction = process.env.REACT_APP_NODE_ENV === "production";

  // Conditionally set the path based on the environment
  const imagePath = isProduction
    ? window.location.hostname.includes("localhost")
      ? "../"
      : "https://www.directmortgage.com/R/"
    : "../";

  // const handleRateOptionClick = (option) => {
  //   // Call the parent function with a message
  //   RateOptionClick(option);
  // };

  const handlePageRedirect = (option) => {
    if (option == 1) {
      window.location.href = "https://www.directmortgage.com";
    }
    if (option == 2) {
      window.location.href = "https://www.directmortgage.com/our-team";
    }
    if (option == 3) {
      window.location.href = "https://www.directmortgage.com/licensing";
    }
    if (option == 4) {
      window.location.href = "https://www.directmortgage.com/privacy-policy";
    }
    if (option == 5) {
      window.location.href = "https://www.directmortgage.com/terms-of-use";
    }
  };
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
    setIsMediumSize(window.innerWidth >= 768 && window.innerWidth < 1201);
    setIsLargeDeskTop(window.innerWidth > 1399);
  };

  useEffect(() => {
    // Add event listener to update state on window resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div className="frameBottom">
        <div
          style={{
            width: "100%",
            height: "auto",
            //  background: "#17202c",
            background: isMobile
              ? `linear-gradient(to top, #17202c 75%, white 25%)`
              : `linear-gradient(to top, #17202c 50%, white 50%)`,
            justifyContent: "center",
            display: "grid",
          }}
          className="container"
        >
          <div className="row">
            <div
              className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
              style={{
                justifyContent: "center",
                display: "grid",
              }}
            >
              <div
                style={{
                  display: "",
                  width: isMobile ? 315 : isMediumSize ? "auto" : 954,
                  height: isMobile ? 77 : 236,
                  //   left: "27%",

                  background:
                    "linear-gradient(180deg, #459946 0%, #367837 100%)",
                  boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.15)",
                  borderTopLeftRadius: 16,
                  borderTopRightRadius: 16,
                  borderBottomLeftRadius: 16,
                  borderBottomRightRadius: 16,
                  // marginLeft: isMobile ? 35 : 0,

                  justifyContent: "center",
                }}
              >
                <div className="row">
                  <div className="col-xs-7 col-sm-6 col-md-5 col-lg-7">
                    <div
                      style={{
                        width: isMobile
                          ? window.innerWidth > 480
                            ? "80%"
                            : "60%"
                          : "100%",
                        color: "white",
                        fontSize: isMediumSize ? 22 : isMobile ? 12 : 30,
                        fontFamily: "Inter",
                        fontWeight: "700",
                        textTransform: "capitalize",
                        wordWrap: "break-word",
                        marginTop: isMobile ? "0rem" : "2rem",
                        marginLeft: isMobile ? "1rem" : "2rem",
                      }}
                    >
                      <div
                        style={{
                          textAlignlign: "left",
                          width: "100%",
                        }}
                      >
                        {" "}
                        you are moments away from a home loan quote
                      </div>
                      <div
                        style={{
                          textAlignlign: "right",
                          width: "100%",
                          justifyContent: "right",
                          display: "grid",
                        }}
                      >
                        <div
                          style={{
                            paddingLeft: isMobile ? 12 : 30,
                            paddingRight: isMobile ? 12 : 30,
                            paddingTop: isMobile ? 2 : 10,
                            paddingBottom: isMobile ? 2 : 10,

                            background:
                              "linear-gradient(0deg, #1a1a1a 0%, #4d4d4d 100%)",
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.25)",
                            borderRadius: 8,
                            border: "1px #090909 solid",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 10,
                            fontSize: isMobile ? 12 : 24,
                            cursor: "pointer",
                            marginTop: isMobile ? "0rem" : "2rem",
                            width: isMobile ? "90px" : "187px",
                            height: "fit-content",
                            marginRight: "4rem",
                            marginTop: "1rem",
                          }}
                          onClick={() => RateOptionClick(12)}
                        >
                          <div
                            style={{
                              color: "#FFFFFF",
                              fontSize: isMobile ? 10 : 24,
                              fontFamily: "Inter",
                              fontWeight: "400",
                              wordWrap: "break-word",

                              width: "fit-content",
                            }}
                          >
                            Apply Now
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-xs-5 col-sm-6 col-md-5 col-lg-5"
                    style={{
                      textAlign: "right",
                      display: LOFooterImage.length > 0 ? "" : "none",
                    }}
                  >
                    <img
                      style={{
                        // width: isMobile ? 120 : 375,
                        // height: isMobile ? 112 : 350,
                        maxHeight: isMobile ? 109 : 350,
                        //left: "35%",
                        //  top: -80,
                        // position: "absolute",
                        // boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.25)",
                        borderRadius: 4,
                        zIndex: isMobile ? "auto" : 9999,
                        //position: "sticky",

                        top: isMobile ? -105 : "auto",
                        position: "relative",

                        marginTop: isMobile
                          ? window.innerWidth > 480
                            ? "4rem"
                            : "0rem"
                          : "-7rem",
                      }}
                      src={LOFooterImage} //"https://www.directmortgage.com/wp-content/uploads/2024/01/Jim3-2.png" //{row.LoPhotoPath} //
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div
              className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
              //style={{ height: 100 }}
            >
              <div
                style={{
                  width: isMobile ? 360 : "100%",
                  height: "100%",
                  padding: isMobile ? 8 : 10,
                  justifyContent: "center",
                  alignItems: "center",
                  display: "inline-flex",
                  top: 0,
                  alignItems: "flex-start",
                  // paddingTop: isMobile ? "3rem" : "5rem",
                }}
              >
                <div
                  style={{
                    textAlign: "center",
                    color: "#B6B6B6",
                    fontSize: isMobile ? 10 : 12,
                    fontFamily: "Inter",
                    fontWeight: "500",
                    //  lineHeight: 14,
                    wordWrap: "break-word",
                    paddingRight: isMobile ? "1rem" : "3rem",
                    cursor: "pointer",
                  }}
                  onClick={() => handlePageRedirect(1)}
                >
                  Home
                </div>
                <div
                  style={{
                    textAlign: "center",
                    color: "#B6B6B6",
                    fontSize: isMobile ? 10 : 12,
                    fontFamily: "Inter",
                    fontWeight: "500",
                    // lineHeight: 14,
                    wordWrap: "break-word",
                    paddingRight: isMobile ? "1rem" : "3rem",
                    cursor: "pointer",
                  }}
                  onClick={() => handlePageRedirect(2)}
                >
                  Loan Officers
                </div>
                <div
                  style={{
                    textAlign: "center",
                    color: "#B6B6B6",
                    fontSize: isMobile ? 10 : 12,
                    fontFamily: "Inter",
                    fontWeight: "500",
                    //lineHeight: 14,
                    wordWrap: "break-word",
                    paddingRight: isMobile ? "1rem" : "3rem",
                    cursor: "pointer",
                  }}
                  onClick={() => handlePageRedirect(3)}
                >
                  Licensing
                </div>
                <div
                  style={{
                    textAlign: "center",
                    color: "#B6B6B6",
                    fontSize: isMobile ? 10 : 12,
                    fontFamily: "Inter",
                    fontWeight: "500",
                    //  lineHeight: 14,
                    wordWrap: "break-word",
                    paddingRight: isMobile ? "1rem" : "3rem",
                    cursor: "pointer",
                  }}
                  onClick={() => handlePageRedirect(4)}
                >
                  Privacy Policy
                </div>
                <div
                  style={{
                    textAlign: "center",
                    color: "#B6B6B6",
                    fontSize: isMobile ? 10 : 12,
                    fontFamily: "Inter",
                    fontWeight: "500",
                    //lineHeight: 14,
                    wordWrap: "break-word",
                    paddingRight: isMobile ? "0rem" : "3rem",
                    cursor: "pointer",
                  }}
                  onClick={() => handlePageRedirect(5)}
                >
                  Terms of Use
                </div>
              </div>
            </div>
          </div>
          <div
            className="row"
            style={{
              //  marginTop: isMobile ? "-4rem" : "-5rem",
              alignItems: "center",
              display: isMobile ? "" : "none",
            }}
          >
            <div
              className="col-xs-12 col-sm-12 col-md-12 col-lg-12"
              style={{
                justifyContent: "center",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                style={{
                  width: 29,
                  height: 30,
                }}
                src={`${imagePath}EqualHousingWhite1.png`}
              />
              <img
                style={{
                  width: 58,
                  height: 50,
                }}
                src={`${imagePath}NMLSWhite1.png`}
              />
            </div>
          </div>
          <div
            className="row"
            style={{
              //  marginTop: isMobile ? "-4rem" : "-5rem",
              alignItems: "center",
            }}
          >
            <div
              className="col-xs-3 col-sm-3 col-md-3 col-lg-3"
              style={{
                textAlign: "center",
                display: isMobile ? "none" : "",
                paddingBottom: 20,
              }}
            >
              <img
                style={{
                  width: isMediumSize ? 124 : 181,
                  height: isMediumSize ? 44 : 77,
                  cursor: "pointer",
                }}
                src={`${imagePath}DMCFooterWhite.png`}
                onClick={() => handlePageRedirect(1)}
              />
            </div>

            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <div
                style={{
                  textAlign: "center",
                  color: "#B6B6B6",
                  fontSize: isMobile ? 8 : isMediumSize ? 9 : 12,
                  fontFamily: "Inter",
                  fontWeight: "500",
                  // lineHeight: 18,
                  wordWrap: "break-word",
                }}
              >
                © 2025 Direct Mortgage, Corp. ALL RIGHTS RESERVED
                <br />
                6955 S. Union Park Center Suite 540, Midvale, UT 84047 | NMLS ID
                9612
              </div>
            </div>

            <div
              className="col-xs-3 col-sm-3 col-md-3 col-lg-3"
              style={{
                textAlign: "center",
                display: isMobile ? "none" : "",
              }}
            >
              <img
                style={{
                  width: isMediumSize ? 24 : 48,
                  height: isMediumSize ? 24 : 48,
                }}
                src={`${imagePath}EqualHousingWhite1.png`}
              />
              <img
                style={{
                  width: isMediumSize ? 50 : 100,
                  height: isMediumSize ? 42 : 85,
                }}
                src={`${imagePath}NMLSWhite1.png`}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
